"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _querystring = _interopRequireDefault(require("querystring"));

var _es = require("@adobe/httptransfer/es2015");

var _logger = _interopRequireDefault(require("@adobe/httptransfer/es2015/logger"));

var _utils = require("./utils");

var _initResponse = _interopRequireDefault(require("./init-response"));

var _uploadError = _interopRequireDefault(require("./upload-error"));

var _errorCodes = _interopRequireDefault(require("./error-codes"));

var _initResponseFilePart = _interopRequireDefault(require("./init-response-file-part"));

var _partUploadResult = _interopRequireDefault(require("./part-upload-result"));

var _httpUtils = require("./http-utils");

var _partUploader = _interopRequireDefault(require("./part-uploader"));

var _httpRequest = _interopRequireDefault(require("./http/http-request"));

var _fileTransferHandler = _interopRequireDefault(require("./file-transfer-handler"));

var _concurrentQueue = _interopRequireDefault(require("./concurrent-queue"));

var _fileUploadResult = _interopRequireDefault(require("./file-upload-result"));

var _uploadFile = _interopRequireDefault(require("./upload-file"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Contains all logic for the process that uploads a set of files using direct binary access.
 *
 * The process will send events as a file is uploaded. Each event will be sent with
 * an object containing the following elements:
 * * {string} fileName: Name of the file being uploaded.
 * * {number} fileSize: Total size of the file, in bytes.
 * * {string} targetFolder: Full path to the AEM folder where the file is being
 *   uploaded.
 * * {string} targetFile: Full path to the file in AEM.
 * * {string} mimeType: Mime type of the file being uploaded.
 *
 * Some events may send additional pieces of information, which will be noted
 * in the event itself. The events are:
 *
 * * filestart: Sent when the first part of a file begins to upload.
 * * fileprogress: Sent periodically to report on how much of the file has
 *   uploaded. The event data will include these additional elements:
 *   * {number} transferred: The total number of bytes that have transferred for
 *     the file so far.
 * * fileend: Sent after the last part of a file has uploaded successfully. Will only
 *   be sent if the file transfers completely.
 * * filecancelled: Sent if the file was cancelled before it could finish.
 * * fileerror: Sent if one of the file's parts failed to transfer. The event data
 *   will include these additional elements:
 *   * {Array} errors: List of errors that occurred to prevent the upload.
 */
var DirectBinaryUploadProcess = /*#__PURE__*/function (_FileTransferHandler) {
  _inherits(DirectBinaryUploadProcess, _FileTransferHandler);

  var _super = _createSuper(DirectBinaryUploadProcess);

  /**
   * Constructs a new instance of the upload process for a single directory.
   * @param {object} options Overall direct binary process options.
   * @param {DirectBinaryUploadOptions} uploadOptions Options specific to the
   *  current upload.
   * @param {HttpClient} [httpClient] Client to use to submit HTTP requests. If
   *  not specified then the process will create its own.
   * @param {PartUpload} [partUploader] Upload to use when uploading file parts.
   *  If not specified then the process will create its own.
   */
  function DirectBinaryUploadProcess(options, uploadOptions) {
    var _this;

    var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var partUploader = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    _classCallCheck(this, DirectBinaryUploadProcess);

    _this = _super.call(this, options, uploadOptions, httpClient);
    _this.partUploader = partUploader;

    if (!_this.partUploader) {
      _this.partUploader = new _partUploader.default(options, uploadOptions, _this.getHttpClient(), new _concurrentQueue.default(options, uploadOptions));
    }

    _this.fileResults = {};
    _this.fileEvents = {};
    _this.fileTransfer = {};
    _this.completeUri = '';
    var log = options.log;

    if (log) {
      _logger.default.debug = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return log.debug.apply(log, args);
      };

      _logger.default.info = function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return log.info.apply(log, args);
      };

      _logger.default.warn = function () {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return log.warn.apply(log, args);
      };

      _logger.default.error = function () {
        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        return log.error.apply(log, args);
      };
    }

    return _this;
  }
  /**
   * Does the work of uploading all files based on the upload options provided to the process.
   *
   * @param {UploadResult} uploadResult Result to which information about the upload will be
   *  added.
   * @returns {Promise} Resolves when all files have been uploaded.
   */


  _createClass(DirectBinaryUploadProcess, [{
    key: "upload",
    value: function () {
      var _upload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(uploadResult) {
        var _this2 = this;

        var aemUpload, aemUploadOptions, fileCount, uploadFileOptions;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                aemUpload = new _es.AEMUpload();
                aemUpload.on('filestart', function (data) {
                  _this2.logInfo("Upload START '".concat(data.fileName, "': ").concat(data.fileSize, " bytes"));

                  _this2.emit('filestart', data);
                });
                aemUpload.on('fileprogress', function (data) {
                  _this2.logInfo("Upload PROGRESS '".concat(data.fileName, "': ").concat(data.transferred, " of ").concat(data.fileSize, " bytes"));

                  _this2.emit('fileprogress', data);
                });
                aemUpload.on('fileend', function (data) {
                  _this2.logInfo("Upload COMPLETE '".concat(data.fileName, "': ").concat(data.fileSize, " bytes"));

                  _this2.emit('fileend', data);
                });
                aemUpload.on('fileerror', function (data) {
                  _this2.logError("Upload FAILED '".concat(data.fileName, "': '").concat(data.errors[0].message, "'"));

                  _this2.emit('fileerror', data);
                });
                aemUploadOptions = (0, _utils.getHttpTransferOptions)(this.getOptions(), this.getUploadOptions());
                fileCount = aemUploadOptions.uploadFiles.length;
                uploadResult.startTimer();
                this.logInfo("sending ".concat(fileCount, " files to httptransfer with options ").concat(JSON.stringify(aemUploadOptions, null, 2)));
                uploadResult.addTotalFiles(fileCount);
                _context.next = 12;
                return aemUpload.uploadFiles(aemUploadOptions);

              case 12:
                this.logInfo('successfully uploaded files with httptransfer');
                uploadResult.stopTimer();
                uploadFileOptions = this.getUploadOptions().getUploadFileOptions ? this.getUploadOptions().getUploadFileOptions() : {}; // for now httptransfer will fail the whole batch if one file fails. "Fake"
                // some upload results here to ensure at least some consistency to the results
                // before introducing the httptransfer module.

                uploadResult.addInitTime(100); // totally wrong, but temporary

                this.getUploadOptions().getUploadFiles().forEach(function (uploadFile) {
                  var uploadFileInstance = new _uploadFile.default(_this2.getOptions(), _this2.getUploadOptions(), _objectSpread({}, uploadFileOptions, {}, uploadFile));
                  var filePart = new _initResponseFilePart.default(_this2.getOptions(), _this2.getUploadOptions(), uploadFileInstance, {
                    uploadToken: '<redacted>',
                    fileName: uploadFileInstance.getFileName(),
                    mimeType: '',
                    maxPartSize: 0,
                    minPartSize: 0,
                    uploadURIs: ['<handled by httptransfer>']
                  }, {
                    start: 0,
                    end: uploadFileInstance.getFileSize(),
                    url: '<handled by httptransfer>'
                  });
                  var partResult = new _partUploadResult.default(_this2.getOptions(), _this2.getUploadOptions(), filePart);
                  partResult.setUploadTime(1000); // totally wrong, but temporary

                  var fileResult = new _fileUploadResult.default(_this2.getOptions(), _this2.getUploadOptions(), filePart);
                  fileResult.setTotalUploadTime(1000); // totally wrong, but temporary

                  fileResult.setTotalCompleteTime(200); // totally wrong, but temporary

                  fileResult.addPartResult(partResult);
                  uploadResult.addFileUploadResult(fileResult);
                }); // output json result to logger

                this.logInfo('Uploading result in JSON: ' + JSON.stringify(uploadResult, null, 4));

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function upload(_x) {
        return _upload.apply(this, arguments);
      }

      return upload;
    }()
    /**
     * Does the work of initiating an upload by calling the initiateUpload servlet.
     *
     * @param {UploadResult} uploadResult Result to which information about the upload will be added.
     * @param {Array} [uploadFiles] If specified, will be used in place of the upload files in the
     *  process's upload options.
     * @returns {InitResponse} Information about the response from the initiateUpload servlet.
     */

  }, {
    key: "initiateUpload",
    value: function () {
      var _initiateUpload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(uploadResult) {
        var _this3 = this;

        var uploadFiles,
            options,
            url,
            targetFolder,
            targetFiles,
            toUpload,
            initRequest,
            initResponse,
            fileListInit,
            response,
            statusCode,
            resObj,
            elapsedTime,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                uploadFiles = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
                options = this.getUploadOptions();
                url = options.getUrl();
                targetFolder = options.getTargetFolderPath();
                targetFiles = uploadFiles ? uploadFiles : options.getUploadFiles();
                toUpload = targetFiles.map(function (upload) {
                  return new _uploadFile.default(_this3.getOptions(), options, upload);
                });
                uploadResult.startTimer();
                initRequest = new _httpRequest.default(this.getOptions(), "".concat(url, ".initiateUpload.json")).withMethod(_httpRequest.default.Method.POST).withContentType('application/x-www-form-urlencoded').withData(_querystring.default.stringify({
                  path: targetFolder,
                  fileName: toUpload.map(function (file) {
                    return file.getFileName();
                  }),
                  fileSize: toUpload.map(function (file) {
                    return file.getFileSize();
                  })
                })).withResponseType(_httpRequest.default.ResponseType.JSON).withUploadOptions(this.getUploadOptions());
                this.logDebug("Initiating upload to ".concat(url));
                _context2.next = 11;
                return this.getHttpClient().submit(initRequest, uploadResult);

              case 11:
                response = _context2.sent;
                statusCode = response.getStatusCode();
                resObj = response.getData();
                elapsedTime = response.getElapsedTime();
                (0, _httpUtils.updateOptionsWithResponse)(options, response);
                this.logInfo("Finished initialize uploading, response code: '".concat(statusCode, "', time elapsed: '").concat(elapsedTime, "' ms"));
                this.logInfo('Init upload result: ' + JSON.stringify(resObj, null, 4));
                initResponse = new _initResponse.default(this.getOptions(), options, toUpload, resObj);
                fileListInit = initResponse.getFiles();

                if (!(!fileListInit.length || !fileListInit[0].getUploadUris().length)) {
                  _context2.next = 22;
                  break;
                }

                throw new _uploadError.default('direct binary access not supported', _errorCodes.default.NOT_SUPPORTED);

              case 22:
                uploadResult.addInitTime(elapsedTime);
                uploadResult.addTotalFiles(fileListInit.length);
                return _context2.abrupt("return", initResponse);

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initiateUpload(_x2) {
        return _initiateUpload.apply(this, arguments);
      }

      return initiateUpload;
    }()
    /**
     * Overridden to send the 'filestart' event.
     * @param {FileUploadResult} fileUploadResult Unused.
     * @param {InitResponseFileInfo} initResponseFileInfo Used to build event data
     *  for the event.
     */

  }, {
    key: "_doFileTransferStarted",
    value: function () {
      var _doFileTransferStarted2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(fileUploadResult, initResponseFileInfo) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.sendEvent('filestart', initResponseFileInfo.getFileEventData());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _doFileTransferStarted(_x3, _x4) {
        return _doFileTransferStarted2.apply(this, arguments);
      }

      return _doFileTransferStarted;
    }()
    /**
     * Overridden to send the 'fileprogress' event.
     * @param {FileUploadResult} fileUploadResult Unused.
     * @param {InitResponseFileInfo} initResponseFileInfo Used to build event data
     *  for the event.
     * @param {object} progressData Information about the progress of the file transfer.
     */

  }, {
    key: "_doFileTransferProgress",
    value: function () {
      var _doFileTransferProgress2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(fileUploadResult, initResponseFileInfo, progressData) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.sendEvent('fileprogress', _objectSpread({}, initResponseFileInfo.getFileEventData(), {}, progressData));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _doFileTransferProgress(_x5, _x6, _x7) {
        return _doFileTransferProgress2.apply(this, arguments);
      }

      return _doFileTransferProgress;
    }()
    /**
     * Overridden to complete the upload process for the file.
     * @param {FileUploadResult} fileUploadResult Used to update complete statistics.
     * @param {InitResponseFileInfo} initResponseFileInfo Used to retrieve various
     *  pieces of information about the file.
     */

  }, {
    key: "_doFileTransferSucceeded",
    value: function () {
      var _doFileTransferSucceeded2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(fileUploadResult, initResponseFileInfo) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.completeUpload(fileUploadResult, initResponseFileInfo));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _doFileTransferSucceeded(_x8, _x9) {
        return _doFileTransferSucceeded2.apply(this, arguments);
      }

      return _doFileTransferSucceeded;
    }()
    /**
     * Overridden to send the 'fileend' event.
     * @param {FileUploadResult} fileUploadResult Unused.
     * @param {InitResponseFileInfo} initResponseFileInfo Used to build event data
     *  for the event.
     */

  }, {
    key: "_doFileTransferError",
    value: function () {
      var _doFileTransferError2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(fileUploadResult, initResponseFileInfo) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.sendEvent('fileerror', _objectSpread({}, initResponseFileInfo.getFileEventData(), {
                  errors: fileUploadResult.getErrors()
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _doFileTransferError(_x10, _x11) {
        return _doFileTransferError2.apply(this, arguments);
      }

      return _doFileTransferError;
    }()
    /**
     * Overridden to send the 'filecancelled' event.
     * @param {FileUploadResult} fileUploadResult Unused.
     * @param {InitResponseFileInfo} initResponseFileInfo Used to build event data
     *  for the event.
     */

  }, {
    key: "_doFileTransferCancelled",
    value: function () {
      var _doFileTransferCancelled2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(fileUploadResult, initResponseFileInfo) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.sendEvent('filecancelled', initResponseFileInfo.getFileEventData());

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _doFileTransferCancelled(_x12, _x13) {
        return _doFileTransferCancelled2.apply(this, arguments);
      }

      return _doFileTransferCancelled;
    }()
  }]);

  return DirectBinaryUploadProcess;
}(_fileTransferHandler.default);

exports.default = DirectBinaryUploadProcess;